import ConfirmationPage from '../../shared/booking/ConfirmationPage';
import PackageSummary from './PackageSummary';

export default function PackageConfirmation() {
  return (
    <ConfirmationPage
      module="packages"
      Summary={PackageSummary}
      refLabel="Holiday reference"
      nextSteps={[
        'A holiday expert will call you within 24 hours to finalise your itinerary.',
        'Flight tickets, hotel vouchers & visa (if included) are shared 7 days before departure.',
        'Keep passports / IDs ready for all travellers.',
        'Track documents and manage your trip from My Trips.',
      ]}
    />
  );
}
